import Constants from 'expo-constants';
import axios from 'axios';

export const getApiUrl = () => {
  // Try different ways to get the API URL
  const expoConfig = Constants.expoConfig;
  const manifest = Constants.manifest2 || Constants.manifest;
  const apiUrl = expoConfig?.extra?.API_URL || manifest?.extra?.API_URL || "https://yc.intuitlms.online/api";

  console.log('getApiUrl called with:', {
    expoConfig: expoConfig?.extra?.API_URL,
    manifest: manifest?.extra?.API_URL,
    finalUrl: apiUrl
  });

  return apiUrl;
};

// Export connection test utility using axios
// Utility to get the full API URL for the current environment
export const getFullApiUrl = () => {
  const apiUrl = getApiUrl();
  console.log('Current API URL:', apiUrl);
  return apiUrl;
};

// Enhanced connection test with detailed logging
export const testConnection = async () => {
  try {
    const apiUrl = getApiUrl();
    console.log('Testing connection to:', apiUrl);

    const instance = axios.create({
      baseURL: apiUrl,
      timeout: 5000,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const response = await instance.get('/api/health');
    console.log('Connection test response:', response.data);
    return response.data.status === 'healthy';
  } catch (error) {
    console.error('Connection test details:', {
      message: error.message,
      code: error.code,
      config: error.config,
    });
    if (error.response) {
      console.error('Response error:', error.response.data);
    }
    return false;
  }
};
